export default {
      id: "security-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#security",
      toString: function () {
        return this.url;
      }
    }